module.exports = __webpack_public_path__ + "img/edc-yokke.a4fe9e95.png";